<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'SearchableFilterPanel',
  mixins: [baseMixin],
  props: {
    title: { type: String, required: true },
    items: { type: Array, default: () => [] },
    maxHeight: { type: Number, required: true },
    isMobile: { type: Boolean, default: false },
    isAnyFilterActive: { type: Boolean, default: false },
    searchKey: { type: String, default: 'label' },
    searchPlaceholder: { type: String, default: '' },
    getFilterCount: { type: Function, required: true },
  },
  emits: ['clear', 'select'],
  data() {
    return {
      searchText: '',
    }
  },
  computed: {
    filteredItems() {
      if (!this.searchText) return this.items
      return this.items.filter((item) =>
        String(item[this.searchKey])
          .toLowerCase()
          .includes(this.searchText.toLowerCase())
      )
    },
  },
}
</script>

<template>
  <div class="filter-panel" :data-filter="`filter-${title}`">
    <!-- Title -->
    <div
      v-if="!isMobile"
      class="filter-title d-flex cursor-pointer"
      style="justify-content: space-between"
    >
      <div class="title mb-3">{{ title }}</div>
      <div
        v-if="isAnyFilterActive"
        class="cursor-pointer clear-filter"
        :class="colorClass.text.primary400"
        data-filter="clear-all-filters"
        @click="$emit('clear')"
      >
        {{ $t('topFilterBar.filter.clearAll') }}
      </div>
    </div>

    <!-- Search Input -->
    <div class="filter-container-search mb-4">
      <v-icon>mdi-magnify</v-icon>
      <input
        v-model="searchText"
        class="ps-2 search-input h-full"
        style="
          width: 100%;
          font-size: 14px;
          font-weight: 400;
          vertical-align: middle;
          outline: none;
        "
        :placeholder="searchPlaceholder"
      />
    </div>

    <!-- Filter List -->
    <div
      ref="filterContainerBox"
      class="filter-container-box"
      :style="{ minHeight: '236px', maxHeight: maxHeight + 'px' }"
    >
      <div v-for="filter in filteredItems" :key="'filter-' + filter.id">
        <div
          class="filter-options"
          :data-filter-option="`filter-options-${filter.label}`"
          @click.stop="$emit('select', filter.id)"
        >
          <div class="d-flex" style="flex-direction: row; align-items: center">
            <v-icon>{{ filter.icon }}</v-icon>
            <div class="options-lable mt-1 ms-2">{{ filter.label }}</div>
          </div>
          <div class="d-flex">
            <div v-if="getFilterCount(filter.id) > 0" class="applied-filter">
              {{ getFilterCount(filter.id) }} {{ title }}
            </div>
            <v-icon>mdi-chevron-right</v-icon>
          </div>
        </div>
      </div>
    </div>

    <!-- No Matches -->
    <div v-if="filteredItems.length === 0" style="text-align: center">
      {{ $t('topFilterBar.filter.noMatchesFound') }}
    </div>
  </div>
</template>

<style lang="scss">
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/booking-top-filter-bar.scss';
</style>
